export const SpecTable = ({ title, rows }) => (
  <div className="mb-8">
    <h3 className="font-data text-[11px] tracking-[0.2em] uppercase text-clara-terracotta border-b border-clara-cream/20 pb-2 mb-1">{title}</h3>
    <table className="w-full font-data text-xs">
      <tbody>
        {rows.map(([k, v]) => (
          <tr key={k} className="border-b border-clara-cream/10">
            <td className="py-2 text-clara-darkmuted">{k}</td>
            <td className="py-2 text-clara-cream text-right">{v}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
